import { Button } from "@fullscript/aviary-web";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import * as styles from "./NavigationFooter.styles";

type Props = {
  previous: string | null;
  previousLink: string | null;
  next: string | null;
  nextLink: string | null;
};

const NavigationFooter = ({ previous, previousLink, next, nextLink }: Props) => {
  return (
    <footer css={styles.footer}>
      {!!previous && !!previousLink && (
        <Button
          variant="secondary"
          to={previousLink}
          customCss={styles.leftButton}
          leftIcon={faChevronLeft}
        >
          {previous}
        </Button>
      )}
      {!!next && !!nextLink && (
        <Button
          variant="secondary"
          to={nextLink}
          customCss={styles.rightButton}
          rightIcon={faChevronRight}
        >
          {next}
        </Button>
      )}
    </footer>
  );
};

export { NavigationFooter };
